import React, {useState} from 'react';
import {useSelector} from 'react-redux';
import {useLocation} from 'react-router-dom';

import {usePrevious} from 'front-onceforall-core/dist/utils/customHooks';

import authenticationService from '../../../../services/authentication/AuthenticationService';
import documentKpiService from '../../../../services/documentKpi/DocumentKpiService';
import {captureError} from '../../../../utils/log';

import {INVITATIONS} from '../../../notification/NotificationData';
import {DOCUMENT_STATES_TO_PROCESS} from '../../../organisationDashboard/ContentWrapper/depositorSection/documentsToProcess/utils/documentStatesToProcess';

import NavView from './NavView';

function NavContainer() {
  const [organisation, notifications] = useSelector(globalState => [
    globalState.organisation,
    globalState.notifications.notificationsWithActions.filter(({type}) => INVITATIONS.includes(type))
  ]);
  const location = useLocation();
  const prevLocation = usePrevious(location);
  const prevOrganisation = usePrevious(organisation);
  const isExplorer = authenticationService.roles().isExplorer();
  const [documentsToProcessCount, setDocumentsToProcessCount] = useState(0);

  async function getCount() {
    try {
      let count = 0;
      if (organisation.depositor && !isExplorer) {
        const documentCountByState = await documentKpiService.getDocumentCountByState(organisation.organisationId);
        DOCUMENT_STATES_TO_PROCESS.forEach(state => {
          count += documentCountByState[state] || 0;
        });
      }

      setDocumentsToProcessCount(count);
    } catch (error) {
      captureError('Error while getting document count by state', error);
    }
  }

  React.useEffect(() => {
    // This is used to virtually decrement the 'document to process' count to avoid sync issues with backend when updating count just after a document has been updated
    function decrementCount() {
      setDocumentsToProcessCount(current => current - 1);
    }

    window.addEventListener('decrementDocumentCount', decrementCount);
    return () => {
      window.removeEventListener('decrementDocumentCount', decrementCount);
    };
  }, []);

  React.useEffect(() => {
    // Update document count if organisation has changed OR
    // if location has changed (to handle the case where the user has updated a document on another screen and then go back to the dashboard)
    if (
      organisation &&
      (
        prevOrganisation !== organisation ||
        (prevOrganisation === organisation && prevLocation !== location && location.pathname === '/dashboard')
      )
    ) {
      getCount();
    }
  }, [organisation, location]);

  return (
    <NavView
      dashboardActionCount={documentsToProcessCount + notifications.length}
    />
  );
}

export default NavContainer;
